import React, { Component, Fragment } from 'react'
import { Icon } from 'loyal-react'
import Showcase from 'Catalog/Showcase'
import Helmet from 'react-helmet'

import '@loyal_template/points_and_cash.css'

class PointsAndCash extends Component {
  render () {
    return (
      <Fragment>
        <Helmet>
          <title>{`Pontos + Dinheiro - ${process.env.REACT_APP_TITLE || ''}`}</title>
        </Helmet>
        <div className='px-0 bg-ui-4'>
          <div className='bg-pointsandcash container-fluid'>
            <div className='container h-100'>
              <div className='row h-100 align-items-center'>
                <div className='col-12'>
                  <h2 className='color-ui-white txt-title-2 txt-circular-black txt-center txt-md-left'>
                    Conheça a melhor forma{' '}
                    <br className='d-none d-md-inline-block' />
                    de resgatar seus prêmios.{' '}
                    <br className='d-none d-md-inline-block' />
                    <span className='color-brand-6'>Pontos</span> +{' '}
                    <span className='color-brand-6'>dinheiro</span>
                  </h2>
                </div>
              </div>
            </div>
          </div>
          <div className='container not-found'>
            <div className='row mx-0 py-3'>
              <div className='col-12 mb-3'>
                <h3 className='h2 txt-center txt-circular-book'>
                  Veja como é simples:
                </h3>
              </div>
              <div className='col-12 col-md bg-white px-3 py-3 radius mt-2 mt-md-0'>
                <div className='row'>
                  <div className='col-12'>
                    <Icon
                      iconName='icon_cart'
                      className='color-brand-1  icon-lg'
                    />
                    <h4 className='txt-circular-book mb-1 mt-2'>
                      Encontre o seu produto e coloque no carrinho
                    </h4>
                    <p className='txt-body-sm'>
                      O catálogo de prêmios conta com milhares de produtos
                      disponíveis para resgate.
                    </p>
                  </div>
                </div>
              </div>
              <div className='col-auto px-2 d-none d-md-flex'>
                <div className='row h-100 align-items-center'>
                  <div className='col-12'>
                    <i className='step-separator ml-auto mr-auto' />
                  </div>
                </div>
              </div>
              <div className='col-12 col-md bg-white px-3 py-3 radius mt-2 mt-md-0'>
                <div className='row'>
                  <div className='col-12'>
                    <Icon
                      iconName='icon_card'
                      className='color-brand-1 icon-lg'
                    />
                    <h4 className='txt-circular-book mb-1 mt-2'>
                      No pagamento escolha pontos + cartão de crédito
                    </h4>
                    <p className='txt-body-sm'>
                      Deslize a barra de pontos até o valor desejado e coloque os
                      dados do cartão.
                    </p>
                    <p className='txt-body-sm pt-1'>
                      A opção do complemento aparece quando você tem pelo menos 30% do valor do produto em pontos e não há saldo suficiente.
                    </p>
                  </div>
                </div>
              </div>
              <div className='col-auto px-2 d-none d-md-flex'>
                <div className='row h-100 align-items-center'>
                  <div className='col-12'>
                    <i className='step-separator ml-auto mr-auto' />
                  </div>
                </div>
              </div>
              <div className='col-12 col-md bg-white px-3 py-3 radius mt-2 mt-md-0'>
                <div className='row'>
                  <div className='col-12'>
                    <Icon
                      iconName='icon_check'
                      className='color-brand-1  icon-lg'
                    />
                    <h4 className='txt-circular-book mb-1 mt-2'>
                      Pronto! Agora é só clicar em finalizar compra
                    </h4>
                    <p className='txt-body-sm'>
                      Acompanhe o seu pedido até a entrega e aproveite as nossas
                      ofertas diárias.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <Showcase showcaseType='5' identifier='home' />
            <Showcase showcaseType='7' identifier='home' />
          </div>
        </div>
      </Fragment>
    )
  }
}

export default PointsAndCash



// WEBPACK FOOTER //
// ./src/features/PointsAndCash/PointsAndCash.js